import axios from "axios";

export const actions = {
    getRefunds(store, params) {
        const { pageSize = 10, page = 1, sorts = null, filters = null } = params;

        let query = `page=${page}&pageSize=${pageSize}`;
        if (sorts) {
            query += `&${sorts}`;
        }
        if (filters) {
            query += `&${filters}`;
        }
        query = encodeURI(query);

        const url = `/tables/refunds?${query}`;
        return axios.get(url);
    },
    addReservationRefunds(store, params) {
        const url = `/refund/addReservationRefunds`;

        return axios.post(url, params);
    },
    addReferralRefunds(store, params) {
        const url = `/refund/addReferralRefunds`;

        return axios.post(url, params);
    },
    voidReservationRefund(store, params) {
        const url = `/refund/voidReservationRefund`;

        return axios.post(url, {
            ...params,
        });
    },
    voidReferralRefund(store, params) {
        const url = `/refund/voidReferralRefund`;

        return axios.post(url, {
            ...params,
        });
    },
};
